module.exports = ".columns {\n  width: 100%;\n  padding: 10px;\n}\n\n.textarea {\n  width: 100%;\n}\n\n.button {\n  margin-left: 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/body-editer/body-editer.component.css
// module id = ./src/app/components/body-editer/body-editer.component.css
// module chunks = main